import styled from 'styled-components';

import Modal from '/components/ui/Modal';
import Heading from '/components/ui/Heading';
import Paragraph from '/components/ui/Paragraph';
import Divider from '/components/ui/Divider';
import Button from '/components/ui/buttons/Button';
import decorateText from '/lib/utils/decorateText';
import ProductPlaceholder from '/components/layout/ProductPlaceholder';
import useProductPage, { emptyPage } from '/hooks/useProductPage';

import dynamic from 'next/dynamic';
import { Material } from '/types/jobTemplateTypes';
const Slider = dynamic(() => import('/components/ui/Slider'), { ssr: false });

interface Props {
    productId?: number;
    material?: Material;
    onClose: () => void;
}

export default function ProductModal({ productId, material, onClose }: Props) {
    const { page: productPage } = useProductPage(productId);

    const page = !material
        ? productPage
        : {
              ...emptyPage,
              id: Number(material.articleNo),
              title: material.friendlyName,
              data: {
                  ...emptyPage.data,
                  images: (material.picture || []).map((img) => ({
                      url: img.url || img.uRL || '',
                  })),
                  description: material.name,
                  content: material.articleDescriptions?.description,
              },
          };

    const stripHTMLTags = (str: string) => {
        const div = document.createElement('div');
        div.innerHTML = str;
        return div.textContent || div.innerText || '';
    };

    const formatText = (text: string) => {
        if (material) {
            return stripHTMLTags(text);
        }
        return decorateText(text);
    };

    console.log('what is page?', productPage);

    return (
        <Modal
            closeRequestCallback={onClose}
            width="740px"
            wrapperClassName="product-modal"
        >
            {page ? (
                <Wrapper className="p-24">
                    {page.data?.images && (
                        <Slider
                            className="mb-16"
                            images={page.data.images}
                            id="product-images"
                            height={'55.92%'}
                        />
                    )}

                    <div className="p-32">
                        <Heading large centered tag="h5" className="mb-12">
                            {formatText(page.title)}
                        </Heading>

                        {page.data?.description && (
                            <Paragraph small weak centered className="mb-48">
                                {formatText(page.data?.description)}
                            </Paragraph>
                        )}

                        {page.data?.content && (
                            <Paragraph medium centered>
                                {formatText(page.data.content)}
                            </Paragraph>
                        )}

                        {page.data.specification && (
                            <Divider className="mt-32 mb-32" />
                        )}

                        <div>
                            {(page.data.specification || []).map((item, i) => (
                                <div
                                    key={item.label + i}
                                    className="flex relative mb-16 justify-space-between"
                                >
                                    <div style={{ width: '45%' }}>
                                        <Paragraph small>
                                            {item.label}
                                        </Paragraph>
                                    </div>
                                    <div style={{ width: '45%' }}>
                                        <Paragraph
                                            small
                                            style={{ textAlign: 'right' }}
                                        >
                                            {item.value}
                                        </Paragraph>
                                    </div>
                                </div>
                            ))}
                        </div>

                        {page.title && <Divider className="mt-32 mb-32" />}

                        <div className="flex justify-center">
                            <Button
                                variant="tertiary"
                                size="small"
                                onClick={onClose}
                            >
                                Lukk
                            </Button>
                        </div>
                    </div>
                </Wrapper>
            ) : (
                <ProductPlaceholder className="p-24" />
            )}
        </Modal>
    );
}

const Wrapper = styled.div`
    position: relative;
    .close {
        position: absolute;
        top: 16px;
        right: 16px;
        width: 48px;
        height: 48px;
        z-index: 10;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        border-bottom-left-radius: 12px;
        background: #fff;
        margin-top: -6px;
        margin-right: -6px;
        @media (max-width: 767px) {
            width: 36px;
            height: 36px;
        }
    }
`;
